export enum WorkflowPageType {
  Simple = 'Simple',
  Detailed = 'Detailed',
}

